export enum Usergroup {
  GROUP_ACCOUNT_OWNER = 'Inhaber',
  GROUP_SUBUSER = 'Mitbenutzer',
}
